const reportDatesCache = new WeakMap<string[], string[]>();

export function parseReportNameToDateString(reportName: string): string {
  return reportName
    .replace('risksystem_daily_risk_report_', '')
    .replace('risksystem_daily_liquidity_risk_report_', '')
    .replace('.pdf', '')
    .replace(/_/g, '-');
}

export function getCachedReportDates(
  reportNames: string[] | undefined,
  parse: (names: string[]) => string[],
): string[] {
  if (!reportNames?.length) return [];
  const cached = reportDatesCache.get(reportNames);
  if (cached) return cached;
  const dates = parse(reportNames);
  reportDatesCache.set(reportNames, dates);
  return dates;
}

export function getDatesFromReportNamesAsStrings(
  reportNames: string[] | undefined,
): string[] {
  return getCachedReportDates(reportNames, (names) =>
    names.map(parseReportNameToDateString),
  );
}

export function findRecentDate(
  dateList: string[],
  date: string,
): string | undefined {
  const recentDate = dateList.find((d) => d <= date);
  if (recentDate) return recentDate;
  return dateList[0];
}

/** First report date on or before `activeDate`, else the first filename's date. Stops early; uses the cache if the full list is already parsed. */
export function findRecentReportDateFromNames(
  reportNames: string[] | undefined,
  activeDate: string,
  parseOne: (reportName: string) => string,
): string | undefined {
  if (!reportNames?.length) return undefined;
  const cached = reportDatesCache.get(reportNames);
  if (cached) return findRecentDate(cached, activeDate);

  let first: string | undefined;
  for (const reportName of reportNames) {
    const date = parseOne(reportName);
    if (!first) first = date;
    if (date <= activeDate) return date;
  }
  return first;
}
